import type { CartLineItem } from 'types/cart/CartLineItem';
import type { Money } from 'types/product/Money';

export const calculateSubscriptionPrice = (
  lineItem: CartLineItem,
): Money | null => {
  if (!lineItem.sellingPlanAllocation) {
    return null;
  }

  return {
    amount: lineItem.sellingPlanAllocation.priceAdjustments[0].price.amount,
    currencyCode:
      lineItem.sellingPlanAllocation.priceAdjustments[0].price.currencyCode,
  };
};
